"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FingerprintsToJSON = exports.FingerprintsFromJSONTyped = exports.FingerprintsFromJSON = void 0;
const _1 = require("./");
function FingerprintsFromJSON(json) {
    return FingerprintsFromJSONTyped(json, false);
}
exports.FingerprintsFromJSON = FingerprintsFromJSON;
function FingerprintsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'wsq': json['wsq'],
        'metadata': _1.KojakScanMetadataModelFromJSON(json['metadata']),
    };
}
exports.FingerprintsFromJSONTyped = FingerprintsFromJSONTyped;
function FingerprintsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'wsq': value.wsq,
        'metadata': _1.KojakScanMetadataModelToJSON(value.metadata),
    };
}
exports.FingerprintsToJSON = FingerprintsToJSON;
//# sourceMappingURL=Fingerprints.js.map